module.exports = __webpack_public_path__ + "static/resume-70611ca0c25304e85024999313f58ee0.pdf";